import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from './store/index'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "inicio",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        // Inicio
        {
          name: "Inicio",
          path: "inicio",
          component: () => import("@/components/Monitor/Monitores"),
        },
        {
          name: "Productos",
          path: "producto/nuevo",
          component: () => import("@/components/Propiedad/Nueva"),
        },
        {
          name: "Productos",
          path: "producto/tipo",
          component: () => import("@/components/Propiedad/Tipo"),
        },
        {
          name: "Usuarios",
          path: "usuarios",
          component: () => import("@/components/Users/Usuario"),
        }, 
        {
          name: "Clientes",
          path: "clientes",
          component: () => import("@/components/Cliente/Client"),
        },
        {
          name: "ClienteDetalle",
          path: "clientes/:id",
          component: () => import("@/components/Cliente/ClienteDetalle"),
        },
        {
          name: "Pedidos",
          path: "pedidos",
          component: () => import("@/components/Cliente/Pedidos"),
        },
        {
          name: "OrdenOperacion",
          path: "operacion",
          component: () => import("@/components/Operacion/OrdenOperacion"),
        },
        {
          name: "Evidencias",
          path: "evidencias",
          component: () => import("@/components/Operacion/Evidencias"),
        },
        {
          name: "CatalogoVisual",
          path: "catalogo",
          component: () => import("@/components/Catalogo/CatalogoVisual"),
        },
        {
          name: "Agenda",
          path: "agenda",
          component: () => import("@/components/Agenda/Agenda"),
        },
        {
          name: "Resenas",
          path: "resenas",
          component: () => import("@/components/Resenas/Resenas"),
        },
        {
          name: "Prospectos",
          path: "prospectos",
          component: () => import("@/components/Seguimiento/SeguimientoLista"),
          props: { tipo: "prospectos" },
        },
        {
          name: "Leads",
          path: "leads",
          component: () => import("@/components/Seguimiento/SeguimientoLista"),
          props: { tipo: "leads" },
        },
        {
          name: "Cerrados",
          path: "cerrados",
          component: () => import("@/components/Seguimiento/SeguimientoLista"),
          props: { tipo: "cerrados" },
        },
        {
          name: "Productos",
          path: "productos",
          component: () => import("@/components/Cliente/Productos"),
        }, 
        {
          name: "Facturas",
          path: "facturas",
          component: () => import("@/components/Cliente/Facturas"),
        },
        {
          name: "Cotizador",
          path: "cotizador",
          component: () => import("@/components/Cotizador/Cotizador"),
        },
        {
          name: "Categorias",
          path: "categorias",
          component: () => import("@/components/Categoria/Categoria"),
        },
        {
          name: "WhatsApp",
          path: "whatsapp",
          component: () => import("@/components/WhatsApp/WhatsAppMessenger"),
        },
        {
          name: "WhatsApp Chat",
          path: "whatsapp/chat/:id",
          component: () => import("@/components/WhatsApp/WhatsAppMessenger"),
        },
        {
          name: "WhatsApp Config",
          path: "whatsapp/config",
          component: () => import("@/components/WhatsApp/Config"),
        },
        {
          name: "WhatsApp Asistente",
          path: "whatsapp/asistente",
          component: () => import("@/components/WhatsApp/Assistant"),
        },
        {
          name: "WhatsApp Campañas",
          path: "whatsapp/campanas",
          component: () => import("@/components/WhatsApp/Campaigns"),
        },
        {
          name: "WhatsApp Nueva Campaña",
          path: "whatsapp/campanas/nueva",
          component: () => import("@/components/WhatsApp/CampaignWizard"),
        },
        {
          name: "WhatsApp Campaña Detalle",
          path: "whatsapp/campanas/:id",
          component: () => import("@/components/WhatsApp/CampaignDetail"),
        },
        {
          name: "WhatsApp Plantillas",
          path: "whatsapp/plantillas",
          component: () => import("@/components/WhatsApp/Templates"),
        },
      ],
      meta: {
        requiresAuth: true
      }
    }, 
    {
      path: "/login",
      name:"login",
      component: () => import("@/layouts/full-layout/Login")
    },
    {
      path: "/cotizacion-print/:id",
      name: "CotizacionPrint",
      component: () => import("@/components/Cotizador/CotizacionPrint"),
      meta: { requiresAuth: true }
    },
    {
      path: "/bandera-interiores",
      name:"Interiores",
      component: () => import("@/components/Banderas/Interior")
    },
    {
      path: "*",
      component: () => import("@/layouts/full-layout/NotFound"),
      meta: {
            requiresAuth: false
          }
    }
  ],
});

import NProgress from "nprogress";
import { esPersonalizado, puedeVer, moduloDeRuta, primeraRutaPermitida } from "@/utils/permisos";

// Rutas permitidas para rol 3 (producción)
const ROL3_ALLOWED = ['/operacion', '/evidencias', '/catalogo', '/pedidos', '/login'];

// Rutas siempre permitidas (sin módulo asociado)
const RUTAS_LIBRES = ['/login', '/'];

router.beforeResolve((to, from, next) => {
  NProgress.start(800);

  store.commit("setRouterHistory", from);

  const userInfo = store.getters.getInfoUser;

  // Usuario Personalizado (permisos granulares): solo rutas de módulos que puede ver
  if (esPersonalizado(userInfo) && RUTAS_LIBRES.indexOf(to.path) === -1) {
    const modulo = moduloDeRuta(to.path);
    // Si la ruta pertenece a un módulo y NO tiene permiso de ver -> redirigir
    if (modulo && !puedeVer(userInfo, modulo)) {
      next(primeraRutaPermitida(userInfo));
      return;
    }
  }

  // Restricción de rol 3 (producción)
  if (userInfo && String(userInfo.rol) === '3') {
    const allowed = ROL3_ALLOWED.some(p => to.path === p || to.path.startsWith(p + '/'));
    if (!allowed) {
      next('/pedidos');
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (store.getters.getInfoUser && store.getters.getInfoUser.admin) {
      next();
      return;
    }
    next('/');
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit("setRouteData", { requireAuth: true });
    if (store.getters.getLoginStatus) {
      next();
      return;
    }
    next('/login');
  } else {
    store.commit("setRouteData", { requireAuth: false });
    next();
  }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
